import { VerifyStatus, FileType, FeeType, LawsuitUpdateStatus } from './enums'
import { Product } from './subscription'

export interface Lawsuit {
  id: number
  createdAt: string
  contractorName: string
  amount: number
  currency: string
  updatedAt: string
  updateTitle: string | null
  actionRequired: boolean
  status: LawsuitStatus
}

export interface LawsuitCircumstanceQuestion {
  id: number
  content: string
  required: boolean
  example?: string
  hint?: string
}

export interface LawyerCase {
  actSignature: string | null
  amount: number
  clientName: string
  contractorName: string
  createdAt: string
  currency: string
  id: number
  status: LawsuitStatus
  updatedAt: string
  updateStatus: LawsuitUpdateStatus
  hasUserActiveSubscription: boolean
}

export enum LawsuitStatus {
  NOT_VERIFIED = 1,
  INCORRECT_DATA,
  WAITING_FOR_PAYMENT,
  CONFIRMATION_UPLOADED,
  INCORRECT_PAYMENT,
  READY_TO_BE_FOLDED,
  ONGOING_PROCEEDINGS,
  PAYMENT_ORDER_ISSUED,
  COURT_VERDICT_ISSUED,
  IN_EXECUTION,
  REJECTED,
  COMPLETED,
  CANCELLED,
}

export interface PartyDetails {
  name: string
  taxNumber: string
  street: string
  apartmentNumber: string
  buildingNumber: string
  city: string
  zipCode: string
  contact: {
    emailAddress: string
    phoneNumber: string | null
    countryId: number
  }
  bankAccountNumber: string | null
  countryId: number
}

export interface LawsuitAnswer {
  id: number
  question: string
  content: string
  remarks: string
  checkStatus: VerifyStatus
}

export interface LawsuitFile {
  id: number
  type: FileType
  name: string
  remarks: string
  checkStatus: VerifyStatus
}

export interface LawsuitDetails {
  actSignature: string | null
  actionRequired: boolean
  administrationFeePaymentStatus: AdministrativePaymentStatus | null
  status: LawsuitStatus
  id: number
  remarks: string | null
  hasUnreadedMessages: boolean
  hasAnyMessages: boolean
  userRemarks: string | null
  statusTimings: {
    id: number
    startedAt: string
    endedAt: string | null
    status: LawsuitStatus
  }[]
  invoice: {
    id: number
    number: string
    contractorName: string
    currency: string
    amount: number
    amountLeft: number
    dueDate: string
    daysLeft: number
  }
  contractor: PartyDetails
  client: PartyDetails
  answers: LawsuitAnswer[]
  files: LawsuitFile[]
  hasUserActiveSubscription?: boolean
}

export interface Message {
  id: number
  from: number
  content: string
  title: string
  createdAt: string
  seen: boolean
  name: string | null
  bankTransfer: {
    recipient: string
    bankAccountNumber: string
    title: string
    amount: number
    currency: string
  } | null
  files: {
    id: number
    name: string
  }[]
}

export interface BankTransfer {
  amount: number
  bankAccountNumber: string
  currencyId: number
  title: string
  recipient: string
  feeType: FeeType
}

export interface LawsuitLinks {
  europeanPaymentOrder: string
  polishPaymentOrder: string
}

export interface CustomerService {
  phoneNumber: string
  emailAddress: string
}

export interface AdministrativePayment
  extends Pick<Product, 'id' | 'identifier' | 'price' | 'currency'> {
  name: string
}

export enum AdministrativePaymentStatus {
  Pending = 1,
  Paid,
  InvoiceSent,
  Error,
}
